export default "__VITE_ASSET__Dmx7J5FA__"